/**
 * ILG Partner Form — V1
 * Handles validation enhancement, honeypot checking, UTM capture, POST submission,
 * success/error states and preserving user-entered data after failure.
 *
 * Security boundary:
 * - No credentials or private keys are stored here.
 * - The configured endpoint must be a public server-side ILG BRAIN endpoint.
 * - The server is responsible for validation, sanitisation, rate limiting and CRM writes.
 */
(function () {
  'use strict';

  function getUtmParams() {
    var params = new URLSearchParams(window.location.search);
    var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
    var result = {};
    keys.forEach(function (key) {
      var value = params.get(key);
      if (value) { result[key] = value; }
    });
    return result;
  }

  function setFieldValidity(field, isValid) {
    var wrapper = field.closest('[data-field-wrapper]');
    if (!wrapper) { return; }
    wrapper.classList.toggle('ilg-partner-form__field--invalid', !isValid);
    field.setAttribute('aria-invalid', isValid ? 'false' : 'true');
  }

  function showStatus(form, type, isVisible) {
    var statusEl = form.querySelector('[data-status="' + type + '"]');
    var otherType = type === 'success' ? 'error' : 'success';
    var otherEl = form.querySelector('[data-status="' + otherType + '"]');
    if (otherEl) { otherEl.classList.remove('is-visible'); }
    if (statusEl) { statusEl.classList.toggle('is-visible', isVisible); }
  }

  function getUserFields(form) {
    return form.querySelectorAll('[data-field-wrapper] input[name], [data-field-wrapper] textarea[name], [data-field-wrapper] select[name]');
  }

  function validateForm(form) {
    var fields = getUserFields(form);
    var valid = true;
    fields.forEach(function (field) {
      var fieldValid = field.checkValidity();
      setFieldValidity(field, fieldValid);
      if (!fieldValid) { valid = false; }
    });
    if (!valid) {
      var firstInvalid = form.querySelector('[aria-invalid="true"]');
      if (firstInvalid) { firstInvalid.focus(); }
    }
    return valid;
  }

  function buildPayload(form) {
    var payload = {};
    getUserFields(form).forEach(function (field) {
      payload[field.name] = field.value.trim();
    });

    payload.source = form.getAttribute('data-source') || 'ILG Brand Partner Landing Page';
    payload.source_page = form.getAttribute('data-source-page') || window.location.href;
    payload.submitted_at = new Date().toISOString();

    var utm = getUtmParams();
    Object.keys(utm).forEach(function (key) { payload[key] = utm[key]; });
    var honeypot = form.querySelector('input[name="hp_field"]');
payload.honeypot = honeypot ? honeypot.value.trim() : '';
    return payload;
  }

  function initForm(form) {
    if (!form || form.getAttribute('data-ilg-initialized') === 'true') { return; }
    form.setAttribute('data-ilg-initialized', 'true');

    getUserFields(form).forEach(function (field) {
      ['input', 'change', 'blur'].forEach(function (eventName) {
        field.addEventListener(eventName, function () {
          if (field.value || eventName === 'blur') {
            setFieldValidity(field, field.checkValidity());
          }
        });
      });
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      showStatus(form, 'error', false);

      if (form.getAttribute('data-disabled') === 'true') { return; }

      var endpoint = form.getAttribute('data-endpoint');
      if (!endpoint) { return; }

      var honeypot = form.querySelector('input[name="hp_field"]');
      if (honeypot && honeypot.value.trim() !== '') {
        // Deliberately do not submit bot-like requests.
        return;
      }

      if (!validateForm(form)) { return; }

      var submitButton = form.querySelector('.ilg-partner-form__submit');
      var originalButtonText = submitButton ? submitButton.textContent : '';
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = 'Submitting…';
      }
      form.setAttribute('aria-busy', 'true');

      var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var timeoutId = controller ? window.setTimeout(function () { controller.abort(); }, 15000) : null;

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(buildPayload(form)),
        signal: controller ? controller.signal : undefined
      })
        .then(function (response) {
          if (!response.ok) { throw new Error('HTTP ' + response.status); }
          return response.json();
        })
        .then(function (data) {
if (!data || data.ok !== true) { throw new Error('Invalid success response'); }
          form.reset();
          form.closest('.ilg-partner-form').classList.add('is-submitted');
          showStatus(form, 'success', true);
        })
        .catch(function () {
          // Preserve the form fields and values on failure.
          showStatus(form, 'error', true);
        })
        .finally(function () {
          if (timeoutId) { window.clearTimeout(timeoutId); }
          form.removeAttribute('aria-busy');
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.textContent = originalButtonText;
          }
        });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-ilg-partner-form]').forEach(initForm);
  }

  initAll(document);

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
